export default "__VITE_ASSET__D$suyF49__"